<core-block-pullout
    [style]="`
          --pullout-image-min-height: 100%;
          --pullout-image-max-height: ${block.data.imageHeight};
          --pullout-image-flex-basis: ${block.data.imageWidth};
          --pullout-body-flex-basis: calc(100% - var(--pullout-image-flex-basis));
          ${block.data.contentPadding && `--pullout-body-padding: ${block.data.contentPadding}`}`"
    [attr.data-theme]="block.data.theme"
    [attr.data-appearance]="block.data.appearance"
    [attr.data-image-padding]="block.data.includeImagePadding ? 'true' : null"
    [attr.data-text-color-override]="block.data.useTextColorOverride ? block.data.textColorOverride : null"
    [attr.data-flat-corners]="block.data.removeBorderRadius ? 'true' : null"
    [eyebrow]="block.data.eyebrow"
    [heading]="block.data.heading"
    [description]="block.data.description"
    [linkText]="block.data.ctaText"
    [linkHref]="block.data.ctaUrl"
    [externalLink]="block.data.isCtaExternalLink"
    [linkAsEntireElement]="showLinkAsEntireElement"
    [image]="block.data.image"
    [imageAltText]="block.data.altText"
    [imagePosition]="block.data.imagePosition"
    [buttonVariant]="block.data.buttonVariant"
    [buttonIcon]="block.data.buttonIcon"
    [buttonIconPlacement]="block.data.buttonIconPosition"></core-block-pullout>
